<template>
  <div class="medical-record-measures" v-if="items.length > 0">
    <div class="medical-record-measure" v-for="(measure, m) in items" :key="m">
      <span class="medical-record-measure-label">{{ measure.label }}</span>
      <span class="medical-record-measure-value">{{ measure.value }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/_variables.scss";

.medical-record-measures {
  display: grid;
  gap: $layout-spacing $layout-spacing-lg;
  grid-template-columns: repeat(auto-fit, minmax(9rem, 1fr));
  .medical-record-measure {
    display: flex;
    flex-direction: column;
    .medical-record-measure-label {
      color: $gray-color-dark;
      font-size: $font-size-sm;
    }
    .medical-record-measure-value {
      font-weight: bold;
    }
  }
}
</style>
